<script setup>
import { computed, ref } from 'vue';
import { useIntervalFn } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import { MESSAGE_STATUS } from './constants';

import Icon from 'next/icon/Icon.vue';
import AnimatedLineIcon from 'next/icon/AnimatedLineIcon.vue';

const { status } = defineProps({
  status: {
    type: String,
    required: true,
    validator: value => Object.values(MESSAGE_STATUS).includes(value),
  },
});

const { t } = useI18n();

const progresIconSequence = [
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
  'i-ph-clock',
];

const progessIcon = ref(progresIconSequence[0]);

const rotateIcon = () => {
  const currentIndex = progresIconSequence.indexOf(progessIcon.value);
  const nextIndex = (currentIndex + 1) % progresIconSequence.length;
  progessIcon.value = progresIconSequence[nextIndex];
};

useIntervalFn(rotateIcon, 500, {
  immediate: status === MESSAGE_STATUS.PROGRESS,
  immediateCallback: false,
});

// SiteUp/F1.4: DELIVERED e READ usam o double-check animado do line-md
// (AnimatedLineIcon, name="check-all") em vez de uma classe estática —
// ver AnimatedLineIcon.vue para o motivo (SMIL não toca via mask-image).
// SENT continua no ícone estático i-ph-check.
const isDoubleCheck = computed(
  () => status === MESSAGE_STATUS.DELIVERED || status === MESSAGE_STATUS.READ
);

const statusIcon = computed(() => {
  const statusIconMap = {
    [MESSAGE_STATUS.SENT]: 'i-ph-check',
  };

  return statusIconMap[status];
});

const statusColor = computed(() => {
  const statusIconMap = {
    [MESSAGE_STATUS.SENT]: 'text-n-slate-10',
    [MESSAGE_STATUS.DELIVERED]: 'text-n-slate-10',
    [MESSAGE_STATUS.READ]: 'text-[#7EB6FF]',
  };

  return statusIconMap[status];
});

const tooltipText = computed(() => {
  const statusTextMap = {
    [MESSAGE_STATUS.SENT]: t('CHAT_LIST.SENT'),
    [MESSAGE_STATUS.DELIVERED]: t('CHAT_LIST.DELIVERED'),
    [MESSAGE_STATUS.READ]: t('CHAT_LIST.MESSAGE_READ'),
    [MESSAGE_STATUS.PROGRESS]: t('CHAT_LIST.SENDING'),
  };

  return statusTextMap[status];
});
</script>

<template>
  <Icon
    v-if="status === MESSAGE_STATUS.PROGRESS"
    v-tooltip.top-start="tooltipText"
    :icon="progessIcon"
    class="text-n-slate-10"
  />
  <AnimatedLineIcon
    v-else-if="isDoubleCheck"
    :key="status"
    v-tooltip.top-start="tooltipText"
    name="check-all"
    :class="statusColor"
    class="size-[14px]"
  />
  <Icon
    v-else
    v-tooltip.top-start="tooltipText"
    :icon="statusIcon"
    :class="statusColor"
    class="size-[14px]"
  />
</template>
